import { unscheduleSuborderOnTransporterOrderRequest, unscheduleSuborderOnTripRequest } from '../../requests';
export default async function unscheduleTransporterOrderEdi({  commit, dispatch }, obj) {

	let response;
	if (obj.type === 'external')
		response = await unscheduleSuborderOnTransporterOrderRequest(obj.id, obj.subOrderId);
	else
		response = await unscheduleSuborderOnTripRequest(obj.id, obj.subOrderId);
	dispatch('tripSearch/fetchTrips');
	commit('setTrip', response);
}